import {
  USER_TAXIPARK_STORAGE_KEY,
  USER_PERMISSIONS_STORAGE_KEY,
  USER_REGIONS_STORAGE_KEY,
  USER_LOCALE_STORAGE_KEY,
  USER_COUNTRY_STORAGE_KEY,
  USER_DEPOSIT_BALANCE_ENABLED_STORAGE_KEY,
} from '~/shared/config/constants'
import { storageGet, storageRemove, storageSet } from '~/shared/lib/storage'
import {
  Country,
  DepositBalanceEnabled,
  Locale,
  Permissions,
  Regions,
  TaxiparkId,
  UserOptionsMe,
  UserOptionsStoreType,
} from './types'

export class UserOptionsStore implements UserOptionsStoreType {
  private readonly storageKeyPermissions = USER_PERMISSIONS_STORAGE_KEY
  private readonly storageKeyTaxipark = USER_TAXIPARK_STORAGE_KEY
  private readonly storageKeyRegions = USER_REGIONS_STORAGE_KEY
  private readonly storageKeyLocale = USER_LOCALE_STORAGE_KEY
  private readonly storageKeyCountry = USER_COUNTRY_STORAGE_KEY
  private readonly storageKeyDepositBalanceEnabled =
    USER_DEPOSIT_BALANCE_ENABLED_STORAGE_KEY

  private fallbackPermissions: Permissions = null
  private fallbackTaxipark: TaxiparkId = null
  private fallbackRegions: Regions = null
  private fallbackLocale: Locale = null
  private fallbackCountry: Country = null
  private fallbackDepositBalanceEnabled: DepositBalanceEnabled = false

  get permissions(): Permissions {
    const storageByKey = storageGet<Permissions>(this.storageKeyPermissions)

    return this.fallbackPermissions || storageByKey
  }
  get taxipark(): TaxiparkId {
    const storageByKey = storageGet<TaxiparkId>(this.storageKeyTaxipark)

    return this.fallbackTaxipark || storageByKey
  }
  get regions(): Regions {
    const storageByKey = storageGet<Regions>(this.storageKeyRegions)

    return this.fallbackRegions || storageByKey
  }
  get locale(): Locale {
    const storageByKey = storageGet<Locale>(this.storageKeyLocale)

    return this.fallbackLocale || storageByKey
  }
  get country(): Country {
    const storageByKey = storageGet<Country>(this.storageKeyCountry)

    return this.fallbackCountry || storageByKey
  }
  get depositBalanceEnabled(): DepositBalanceEnabled {
    const storageByKey = storageGet<DepositBalanceEnabled>(
      this.storageKeyDepositBalanceEnabled,
    )

    return this.fallbackDepositBalanceEnabled || storageByKey || false
  }

  saveTaxipark(taxipark: TaxiparkId) {
    storageSet<TaxiparkId>(this.storageKeyTaxipark, taxipark)
    this.fallbackTaxipark = taxipark
  }

  save(options: UserOptionsMe) {
    const { permissions, taxipark, regions, locale } = options

    const taxiparkId = taxipark?.id || ''
    const country = taxipark?.country || null
    const depositBalanceEnabled = taxipark?.depositBalanceEnabled || false

    storageSet<Permissions>(this.storageKeyPermissions, permissions)
    storageSet<TaxiparkId>(this.storageKeyTaxipark, taxiparkId)
    storageSet<Regions>(this.storageKeyRegions, regions)
    storageSet<Locale>(this.storageKeyLocale, locale)
    storageSet<Country>(this.storageKeyCountry, country)
    storageSet<DepositBalanceEnabled>(
      this.storageKeyDepositBalanceEnabled,
      depositBalanceEnabled,
    )

    this.fallbackPermissions = permissions
    this.fallbackTaxipark = taxiparkId
    this.fallbackRegions = regions
    this.fallbackLocale = locale
    this.fallbackCountry = country
    this.fallbackDepositBalanceEnabled = depositBalanceEnabled
  }

  clear() {
    storageRemove(this.storageKeyPermissions)
    storageRemove(this.storageKeyTaxipark)
    storageRemove(this.storageKeyRegions)
    storageRemove(this.storageKeyDepositBalanceEnabled)

    this.fallbackPermissions = null
    this.fallbackTaxipark = null
    this.fallbackRegions = null
    this.fallbackCountry = null
    this.fallbackDepositBalanceEnabled = false
  }
}
